var _defs, _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 2050 2050",
    "data-name": "Layer 3",
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-2{fill:#ffffff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.7,723.4v-53a171.2,171.2,0,0,0-171.2-171.2h-925A171.2,171.2,0,0,0,391.3,670.4v53a20.1,20.1,0,0,0,20.1,20.1H1638.6A20.1,20.1,0,0,0,1658.7,723.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.3,853.6v526a171.2,171.2,0,0,0,171.2,171.2h925a171.2,171.2,0,0,0,171.2-171.2v-526a20.1,20.1,0,0,0-20.1-20.1H411.4A20.1,20.1,0,0,0,391.3,853.6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 559.2,
    cy: 624.1,
    r: 38.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 678.5,
    cy: 624.1,
    r: 38.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 797.8,
    cy: 624.1,
    r: 38.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/ui-ux.5a5d758b3e3f44fdd13edfc65aaac650.svg";
export { ForwardRef as ReactComponent };